import React from 'react';
import { connect } from "react-redux";
import { push } from 'react-router-redux';
import { branch, compose, lifecycle, renderComponent, withProps } from "recompose";
import { bindActionCreators } from 'redux';
import { isBusinessAdmin, isTeamManager } from '../../../../services';
import { businessSelector } from '../../../../state/modules/business';
import { publisherActions } from '../../../../state/modules/publisher';
import { taskActions } from '../../../../state/modules/task';
import { taskSelector } from '../../../../state/modules/task/selectors';
import { currentUserSelector } from '../../../../state/modules/user/selectors';
import Loading from '../../loading';
import SetTaskContent from './partials/set-task-content';

const TaskEdit = ({
  task
}) => (<div id="task-edit">
  <SetTaskContent task={task} readOnly={false} />
</div>);

const mapStateToProps = (state) => ({
  isBusinessAdmin: isBusinessAdmin(state.user.currentUser),
  task: taskSelector(state),
  isFetchingTask: state.task.isFetching,
  business: businessSelector(state),
  user: currentUserSelector(state),
  publishersResult: state.publisher.publishers,
  isFetchingPublishers: state.publisher.isFetching,
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
  getTask: bindActionCreators(taskActions.task.get, dispatch),
  getPublishers: bindActionCreators(publisherActions.publishers.get, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ business, user }) => ({
      isTeamManager: isTeamManager(user, business)
    })
  ),
  branch(
    ({ isBusinessAdmin, isTeamManager }) => !isBusinessAdmin && !isTeamManager,
    renderComponent(Loading)
  ),
  withProps(({
    match: {
      params: {
        taskId
      }
    }
  }) => ({
    taskId
  })),
  lifecycle({
    componentWillMount() {
      const {
        taskId,
        getTask,
        getPublishers
      } = this.props;

      getPublishers();
      getTask(taskId);
    }
  }),
  branch(
    ({ publishersResult, isFetchingPublishers }) => publishersResult.length === 0 || isFetchingPublishers,
    renderComponent(Loading)
  ),
  branch(
    ({ isFetchingTask, task, taskId }) => (isFetchingTask) || (!task) || task.id !== parseInt(taskId, 10),
    renderComponent(Loading)
  )
)(TaskEdit)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/task-edit.js